import type { InputBaseComponentProps } from '@mui/material';
import { castArray } from 'lodash-es';
import type { ElementType, FC } from 'react';
import { TextField } from '../TextField';
import NumberFormat from './NumberFormat';
import type { NumberFormatWrapperProps } from './NumberFormat.types';

const NumberFormatWithWrapper: FC<NumberFormatWrapperProps> = ({
  currencyInput = true,
  ...rest
}) => {
  const allowDecimal = rest.field?.additional_data?.allowDecimal ?? true;
  return (
    <TextField
      {...rest}
      sx={[(theme) => theme.mixins.resetNumberInputStyle, ...castArray(rest.sx)]}
      type={currencyInput ? 'text' : 'number'}
      InputProps={{
        inputComponent: currencyInput
          ? (NumberFormat as ElementType<InputBaseComponentProps>)
          : undefined,
      }}
      inputProps={{
        allowDecimal,
        prefix: rest?.inputProps?.prefix,
        inputMode: allowDecimal ? 'decimal' : 'numeric',
      }}
    />
  );
};

export default NumberFormatWithWrapper;
